import * as React from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router-dom';

import { BuscarAlumnos, Inscribir } from './componentes';

const TomaDeHorarios: React.FunctionComponent<RouteComponentProps<{}>> = () => {
    return (
        <Switch>
            <Route exact path='/horarios/inscribir' component={BuscarAlumnos} />
            <Route path='/horarios/inscribir/:id' component={Inscribir} />
        </Switch>
    );
};

export default TomaDeHorarios;



// WEBPACK FOOTER //
// ./src/modulos/Horarios/TomaDeHorarios/index.tsx